import { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { getSurveyDetails } from "../../../services/survey/survey.service";
import Layout1 from "../../../assets/layout_1.png";
import Layout2 from "../../../assets/layout_2.png";
import { useTranslation } from "react-i18next";

const SurveyLinkRedirect = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const { surveyId, code, languageId } = useParams();
  const location = useLocation();
  const [selectedLanguage, setSelectedLanguage] = useState(languageId);
  const sessionLanguageDetails = JSON.parse(sessionStorage.getItem("selectedLanguageDetails") || "{}");
  const layoutData = [
    { name: 'Layout One', id: 100, selected: false, imageUrl: Layout1, color: '#F5F5F5' },
    { name: 'Layout Two', id: 101, selected: false, imageUrl: Layout2, color: '#E6E6FA' }
  ]
  const isSurveyResponseSubmitted = sessionStorage.getItem("isSurveyResponseSubmitted") || 'false';

  useEffect(() => {
    if (sessionLanguageDetails) {
      setSelectedLanguage(sessionLanguageDetails?.id);
    }
  }, [sessionLanguageDetails, i18n.language])

  useEffect(() => {
    sessionStorage.setItem('externalUserSurveyWarningShown', 'false');
    sessionStorage.setItem("isExternalUserQuestionsPageOpen", false);
    // sessionStorage.removeItem("userSurveyInfo");

    let token = '';

    const oktaTokenObj = JSON.parse(sessionStorage.getItem("okta-token-storage") || "{}");
    // Check if the user is logged in via Okta
    if (oktaTokenObj && Object.keys(oktaTokenObj).length > 0) {
      token = oktaTokenObj?.idToken?.idToken;
    } else {
      // const isMasalPresent = sessionStorage.getItem("isMasalTokenInStorage");
      // let msalToken = null;
      // if (isMasalPresent === 'true') {
      //   msalToken = 'true';
      // }
      const msalTokenRaw = localStorage.getItem("msal-token-storage");
      let msalToken = null;
      if (msalTokenRaw) {
        try {
          msalToken = JSON.parse(msalTokenRaw);
        } catch {
          msalToken = null;
        }
      }
      token = msalToken || '';
    }
    // Set survey layout details
    sessionStorage.setItem("layoutData", JSON.stringify(layoutData));

    if (token) {
      // Only remove userSurveyInfo when user is authenticated
      localStorage.removeItem("userSurveyInfo");

      if (isSurveyResponseSubmitted === 'true') {
        navigate("/user/survey/user-response-page");
      } else {
        fetchUserSurveyDetails(surveyId, code, selectedLanguage);
      }
    } else {
      sessionStorage.setItem("isExternalUserSurvey", false)
      localStorage.setItem(
        "userSurveyInfo",
        JSON.stringify({ surveyId: surveyId, code: code, languageId: selectedLanguage })
      );
      
      // Use requestAnimationFrame to ensure sessionStorage operations complete
      requestAnimationFrame(() => {
        setTimeout(() => {
          navigate("/login");
        }, 500);
      });
    }
  }, [navigate, surveyId, location, i18n.language]);

  const fetchUserSurveyDetails = (surveyId, code, languageId) => {
    const data = {
      surveyId: surveyId,
      code: code,
      languageId: languageId,
    }
    getSurveyDetails(data).then((response) => {
      if (response?.message) {
        sessionStorage.setItem("isExternalUserSurvey", true)
        navigate("/user/survey/user-response-page");
        return;
      } else {
        const redirectToSurvey = () => {
          sessionStorage.setItem("isExternalUserSurvey", true)
          navigate("/user/survey/opening-page", { state: response?.data[0] });
        };
        sessionStorage.setItem("isExternalUserSurvey", false)
        localStorage.setItem(
          "userSurveyInfo",
          JSON.stringify({ surveyId: surveyId, code: code, languageId: languageId })
        );
        redirectToSurvey();
      }
    })
  };

  return null;
};

export default SurveyLinkRedirect;